import React, { Component } from "react";
import { GetTitleAndMetaTags } from "../../Code/Data";
import { Helmet } from "react-helmet";

export default class TitleAndMetaTags extends Component {
  constructor() {
    super();
    this.state = {
      title:
        "Charity|Choice Donation Gift Card: Virtual Events, COVID19 staying in touch, Birthday, Branded Business Gift Ideas,",
      keywords: "",
      description:
        "The pioneer and leading Charity Gift, (also, an Official donation site of the Red Cross); offering 'giving back' for over 2000 charities. In lieu of, instead of standard gifts, as last-minute eGifts. Perfect for Virtual Events and keeping in touch with clients during COVID-19. Upload CSV file of recipients, robust corporate branding suite.",
      robots: "index, follow",
    };
  }

  async componentDidMount() {
    if (this.props.pageName) {
      const tmt = await GetTitleAndMetaTags(this.props.pageName),
        { title, keywords, description, robots } = this.state;
      this.setState({
        title: tmt.PageTitle || title,
        keywords: tmt.Keywords || keywords,
        description: tmt.Description || description,
        robots: tmt.Robots || robots,
      });
    }
  }

  render() {
    return (
      <Helmet>
        <meta name="keywords" content={this.state.keywords} />
        <meta name="description" content={this.state.description} />
        <meta name="robots" content={this.state.robots} />
        <title>{this.state.title}</title>
      </Helmet>
    );
  }
}
